import * as icons from "react-icons/all";
import ConvSecToMin from "./ConvSecToMin"

const AddClassToCard = (data, tipoChiamata ) => {
    let classObj = {}

    if(tipoChiamata === null ) {
        classObj = { cName: "summary-card-blu",
        cTextName: "summary-title-blu",
        ChartType: {
                    cDivtitle: "cDivtitle",
                    ctitlelabel: "titleLabel",
                    labelFlow: "Durata media chiamate",
                    },
        icon: <icons.HiOutlinePhone size="40" color="rgba(0, 102, 255, 0.3)" />,
        text: "Chiamate in entrata",
        amount: ConvSecToMin(data?.result)
            };
    } else if (tipoChiamata === 2) {
    classObj = { 
        cName: "summary-card-gold",
        cTextName: "summary-title-gold",
        ChartType: {
                    cDivtitle: "cDivtitle",
                    ctitlelabel: "titleLabel",
                    labelFlow: "Durata media ricevute",
                    },
        icon: <icons.BiPhoneIncoming size="40" color="rgba(246, 194, 62, 0.4)" />,
        text: "Chiamate in entrata",
        amount: ConvSecToMin(data?.result)
            }
                    
    } else if (tipoChiamata === 1) {
    classObj = {
        cName: "summary-card-green",
        cTextName: "summary-title-green",
        ChartType: {
                cDivtitle: "cDivtitle",
                ctitlelabel: "titleLabel",
                labelFlow: "Durata media effettuate",
                },
        icon: <icons.BiPhoneOutgoing size="40" color="rgba(49, 228, 64, 0.400)" />,
        text: "Chiamate in uscita",
        amount: ConvSecToMin(data?.result)
        }
    } else if (tipoChiamata === 3) {
        classObj = {
            cName: "summary-card-red",
            cTextName: "summary-title-red",
            ChartType: {
                cDivtitle: "cDivtitle",
                ctitlelabel: "titleLabel",
                labelFlow: "Tentativi di chiamata",
                },
            icon: <icons.MdOutlinePhoneMissed size="40" color="rgba(255, 0, 0, 0.3)" />,
            text: "Percentuale Chiamate Perse",
            amount: data.percentualeDiNonRisposte+"%",
            tentativiEffettuati:data.tentativiEffettuatiCount,
            chiamateEffettuate:data.chiamateEffettuateCount
        }
    } else if(Array.isArray(tipoChiamata) && tipoChiamata.indexOf(2) !== -1 && tipoChiamata.indexOf(3) !== -1) {
        classObj = {
            cName: "summary-card-purple",
            cTextName: "summary-title-purple",
            ChartType: {
                        cDivtitle: "cDivtitle",
                        ctitlelabel: "titleLabel",
                        labelFlow: "Tentativi chiamata media"
                    },
            icon: <icons.HiOutlinePhoneMissedCall size="40" color="rgba(149, 68, 212, 0.3)" />,
            text: "Tentativi chiamata media",
            amount: data
        };
    }

    return classObj;
} 


export default AddClassToCard;
